export default __webpack_public_path__ + "static/3-d7af313f86e8a875da071a7ae9d5c191.jpeg";